import printerIcon from '@SvgIcon/printer.svg'
import facebookIcon from '@SvgIcon/social-facebook.svg'
import xIcon from '@SvgIcon/social-x.svg'

import $ from 'jquery'
import svgIconHtml from '../../../shared/svgIconHtml'

export default {
  // language=HTML
  template: `
    <div class="social-share">
      <a 
          class="social-share-button facebook" 
          :href="facebookUrl" 
          @click="openShareWindow">
        ${svgIconHtml(facebookIcon)}
        <span class="social-share-button__caption">Like</span>
      </a>
      <a 
          class="social-share-button x" 
          :href="xUrl"
          @click="openShareWindow">
        ${svgIconHtml(xIcon)}
        <span class="social-share-button__caption">Post</span>
      </a>
      <a
          v-if="print" 
          class="social-share-button print"
          href="javascript:window.print()">
        ${svgIconHtml(printerIcon)}
        <span class="social-share-button__caption">Print</span>
      </a>
    </div>
  `,
  props: {
    url: {
      type: String,
      default: window.location.href,
    },
    text: {
      type: String,
      default() {
        return $.trim($('meta[name=description]').attr('content') || $(document).prop('title'))
      },
    },
    print: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    encodedUrl() {
      return encodeURIComponent(this.url)
    },

    encodedText() {
      return encodeURIComponent(this.text)
    },

    facebookUrl() {
      return `https://facebook.com/sharer/sharer.php?u=${this.encodedUrl}`
    },

    xUrl() {
      let url = `https://x.com/share?url=${this.encodedUrl}`
      if (this.text) {
        url += `&text=${this.encodedText}`
      }
      return url
    },
  },
  methods: {
    openShareWindow(ev) {
      ev.preventDefault()
      window.open(
        ev.currentTarget.getAttribute('href'),
        null,
        'width=600, height=400, location=0, ' +
          'menubar=0, resizeable=0, scrollbars=0, status=0, titlebar=0, toolbar=0',
      )
    },
  },
}
